import Component from "@base/Component.js";
import api from "@api/api.js";
import t from "@/services/translationService.js";

/** Contact form → POST /api/post/contact (multipart, matching the backend). */
export default class ContactForm extends Component {
  render() {
    return `
      <section class="contact">
        <header class="page-intro">
          <h1 class="page-intro__title">${t.t("contact.title")}</h1>
          <div class="page-intro__rule"></div>
        </header>
        <form class="contact-form">
          <div class="contact-row">
            <label>${t.t("contact.firstName")}<input name="firstName" required /></label>
            <label>${t.t("contact.lastName")}<input name="lastName" required /></label>
          </div>
          <label>${t.t("contact.email")}<input type="email" name="email" required /></label>
          <label>${t.t("contact.message")}<textarea name="message" rows="6" required></textarea></label>
          <!-- Honeypot: hidden from humans, so anything that fills it is a bot.
               The backend silently discards those submissions. aria-hidden +
               tabindex keep it out of the way of screen readers and keyboard
               navigation; autocomplete="off" stops browsers filling it in. -->
          <div class="contact-hp" aria-hidden="true">
            <label>Website<input type="text" name="website" tabindex="-1" autocomplete="off" /></label>
          </div>
          <div class="form-error" role="alert"></div>
          <div class="form-success" role="status"></div>
          <button type="submit" class="btn-primary">${t.t("contact.send")}</button>
        </form>
      </section>`;
  }

  onMounted() {
    const form = this.$(".contact-form");
    const errorEl = this.$(".form-error");
    const okEl = this.$(".form-success");
    const submit = this.$('button[type="submit"]');

    this.listen(form, "submit", async (e) => {
      e.preventDefault();
      errorEl.textContent = "";
      okEl.textContent = "";
      submit.disabled = true;
      submit.textContent = t.t("contact.sending");
      try {
        await api.post("/api/post/contact", new FormData(form), { isForm: true });
        okEl.textContent = t.t("contact.success");
        form.reset();
      } catch (err) {
        errorEl.textContent = err.message || t.t("contact.error");
      } finally {
        submit.disabled = false;
        submit.textContent = t.t("contact.send");
      }
    });
  }
}
